import { normalize } from 'normalizr';
import { ofType } from 'redux-observable';
import { mergeMap, exhaustMap } from 'rxjs/operators';

import { USER_ENDPOINT } from '@perpay-web/constants/urls';
import {
    verifyIdentitySuccess,
    verifyIdentityError,
    verifyIdentityServiceError,
    analyticsAttemptIdentityVerification,
    analyticsIdentityVerificationFailure,
} from '@perpay-web/fintech/actions/entities/identityVerification';
import { replaceUserInfo } from '@perpay-web/fintech/actions/entities/userInfo';
import { identityVerificationStepsSetStep } from '@perpay-web/fintech/components/screens/IdentityVerification/useIdentityVerificationStepsContext';
import { BACKEND_VERIFY_IDENTITY } from '@perpay-web/fintech/constants/actionTypes';
import { MAX_SSN_VERIFICATION_ATTEMPTS } from '@perpay-web/fintech/constants/identityVerificationConstants';
import {
    SUCCESS_STEP,
    FAILURE_STEP,
} from '@perpay-web/fintech/constants/steps/identityVerificationSteps';
import { userInfo } from '@perpay-web/fintech/normalizers/schemas';
import { handleError } from '@perpay-web/observable/operators/handleError';
import { standardizeError } from '@perpay-web/utils/errorHandlers';

export function verifyIdentity(action$, unusedState$, { patch }) {
    return action$.pipe(
        ofType(BACKEND_VERIFY_IDENTITY),
        exhaustMap((action) => patch(USER_ENDPOINT, action.payload)),
        mergeMap((results) => {
            const normalized = normalize(results.response, userInfo);
            const { ssnIsVerified, ssnVerificationAttempts } = results.response;

            const failedIdv =
                ssnVerificationAttempts >= MAX_SSN_VERIFICATION_ATTEMPTS;

            return [
                verifyIdentitySuccess(results.response),
                replaceUserInfo(normalized.entities.userInfo),
                analyticsAttemptIdentityVerification(),
                // failedIdv and ssnIsVerified will never be true at the same time
                ...(failedIdv
                    ? [
                          analyticsIdentityVerificationFailure(),
                          identityVerificationStepsSetStep(FAILURE_STEP),
                      ]
                    : []),
                ...(ssnIsVerified
                    ? [identityVerificationStepsSetStep(SUCCESS_STEP)]
                    : []),
            ];
        }),
        handleError((error) => {
            const standardizedError = standardizeError(error);
            if (error.status >= 500) {
                return [verifyIdentityServiceError(standardizedError)];
            }
            return [verifyIdentityError(standardizedError)];
        }),
    );
}
